export const PAGE_CONTENT_REQUEST_HEADER = 'page-context-request';
export const GLOBAL_WINDOW_STORE_KEY = '__GLOBAL_WINDOW_STORE__';
export const INDEXED_DB_VERSION = '3.1.3';
